"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UICoreOffCanvas = void 0;
const UICoreDrillDown_1 = require("./UICoreDrillDown");
class UICoreOffCanvas {
    /**
     * Add off-canvas menu functionality
     * @param {Boolean} useDrillDown - Add drilldown functionality
     */
    offCanvas(useDrillDown = false) {
        document.addEventListener('DOMContentLoaded', () => {
            try {
                this.nodeList = document.getElementsByClassName('off-canvas');
            }
            catch (e) {
                console.log(e);
                return;
            }
            for (let i = 0; i < this.nodeList.length; i++) {
                //Close on init
                document.getElementsByClassName('off-canvas')[i].classList.add('is-closed');
                // Add overlay div if the menu is fixed (only first element)
                if (getComputedStyle(document.getElementsByClassName('off-canvas')[i]).position === 'fixed') {
                    document.getElementsByClassName('off-canvas')[0].outerHTML += '<div class="js-off-canvas-overlay"></div>';
                }
            }
            this._handleEvents();
            this._handleKeyboardEvents();
            if (useDrillDown) {
                new UICoreDrillDown_1.UICoreDrillDown().generateDrillDown();
            }
        });
    }
    _handleEvents() {
        document.addEventListener('click', (e) => {
            const clickElement = e.target;
            const parentNode = clickElement.parentNode;
            const bodyElement = document.getElementsByTagName('body')[0];
            const overlayElement = document.getElementsByClassName('js-off-canvas-overlay')[0];
            if (parentNode) {
                if (null !== parentNode.getAttribute('data-close')) {
                    bodyElement.classList.remove('no-scroll');
                    const canvasElement = clickElement.closest('[data-off-canvas]');
                    if (canvasElement.classList.contains('is-open')) {
                        if (overlayElement.classList.contains('is-visible')) {
                            overlayElement.classList.remove('is-visible');
                        }
                        canvasElement.classList.remove('is-open');
                        const animationTimeout = setTimeout(() => {
                            canvasElement.classList.add('is-closed');
                            clearTimeout(animationTimeout);
                        }, 500);
                    }
                }
                else if (null !== clickElement.getAttribute('data-toggle') || null !== clickElement.getAttribute('data-open')) {
                    if (bodyElement.classList.contains('no-scroll')) {
                        bodyElement.classList.remove('no-scroll');
                    }
                    else {
                        bodyElement.classList.add('no-scroll');
                    }
                    const canvasElement = null !== document.getElementById(clickElement.getAttribute('data-open')) ? document.getElementById(clickElement.getAttribute('data-open')) : document.getElementById(clickElement.getAttribute('data-toggle'));
                    if (null !== canvasElement) {
                        overlayElement.classList.add('is-visible');
                        canvasElement.classList.add('is-open');
                        canvasElement.classList.remove('is-closed');
                    }
                }
            }
            // Close the off-canvas menu when overlay is clicked
            if (clickElement.classList.contains('js-off-canvas-overlay')) {
                clickElement.classList.remove('is-visible');
                bodyElement.classList.remove('no-scroll');
                for (let i = 0; i < this.nodeList.length; i++) {
                    const canvasElement = document.getElementsByClassName('off-canvas')[i];
                    if (canvasElement.classList.contains('is-open')) {
                        canvasElement.classList.remove('is-open');
                        const animationTimeout = setTimeout(() => {
                            canvasElement.classList.add('is-closed');
                            clearTimeout(animationTimeout);
                        }, 500);
                    }
                }
            }
        }, false);
    }
    _handleKeyboardEvents() {
        document.addEventListener('keydown', e => {
            if (e.which === 27 || e.keyCode === 27) {
                const bodyElement = document.getElementsByTagName('body')[0];
                for (let i = 0; i < this.nodeList.length; i++) {
                    if (document.getElementsByClassName('off-canvas')[i].classList.contains('is-open')) {
                        const overlayElement = document.getElementsByClassName('js-off-canvas-overlay')[0];
                        bodyElement.classList.remove('no-scroll');
                        overlayElement.classList.remove('is-visible');
                        document.getElementsByClassName('off-canvas')[i].classList.remove('is-open');
                        const animationTimeout = setTimeout(() => {
                            document.getElementsByClassName('off-canvas')[i].classList.add('is-closed');
                            clearTimeout(animationTimeout);
                        }, 500);
                    }
                }
            }
        }, false);
    }
}
exports.UICoreOffCanvas = UICoreOffCanvas;
